import api from "./api";

export async function createDoc({
  title,
  description,
  fileId,
  semesterId,
  is_public = true,
}) {
  const jwt = localStorage.getItem("jwt");

  const payloadData = {
    title,
    description,
    is_public,
    file: fileId,
  };

  if (semesterId) {
    payloadData.semester = semesterId;
  }

  const res = await api.post(
    "/api/docs",
    {
      data: payloadData,
    },
    {
      headers: { Authorization: `Bearer ${jwt}` },
    }
  );

  return res.data.data;
}

export async function fetchDocs({ semesterId } = {}) {
  const params = {
    populate: {
      file: true,
      semester: true,
    },
    sort: "createdAt:desc",
  };

  if (semesterId) {
    params.filters = {
      semester: { id: { $eq: semesterId } },
    };
  }

  const res = await api.get("/api/docs", { params });
  return res.data.data;
}

export async function deleteDocInfo(id) {
  const jwt = localStorage.getItem("jwt");
  const res = await api.delete(`/api/docs/${id}`, {
    headers: { Authorization: `Bearer ${jwt}` },
  });
  return res.data;
}
